import { Component, OnInit, Input, Output, ViewEncapsulation } from "@angular/core";
import { IProofReading, FlowType } from "src/app/models/proofreading.model";
import { IHistoriesHandler, IVersionSelector, ProofreadingHistoryService } from "src/app/services/proofreading-history.service";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { EventEmitter } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { CLIENT_CONFIG } from "src/config";



interface IThumbnail {
    src: string;
}
@Component({
    selector: 'app-flows-version-selector',
    templateUrl: './flows-version-selector.component.html',
    styleUrls: ['./flows-version-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class FlowsVersionSelectorComponent implements OnInit {
    @Input() mode: 'intern' | 'extern';
    @Input() compare: boolean = false;

    @Output() versionSelected = new EventEmitter<IVersionSelector | null>();

    public _selectedVersion: IVersionSelector | null = null;

    get selectedVersion() {
        return this._selectedVersion;
    }

    get projectHistory() {
        return this.s_proofreadingHistory.projectHistories;
    }

    get hasArchive() {
        return this.projectHistory.some(ph => ph.from_archive);
    }
    showArchivedHistory = false;

    get ObjectKeys() {
        return Object.keys;
    }

    constructor(
        protected s_auth: AuthService,
        protected s_proofreadingHistory: ProofreadingHistoryService
    ) { }

    async ngOnInit(): Promise<void> {
        this.resetSelectedVersion();
    }

    getPrefixRelecture(flow: FlowType) {
        return ProofreadingService.getPrefixRelecture(flow);
    }

    selectVersion(id: string, flow: FlowType, relecture: number, version?: number) {
        this._selectedVersion = { id, flow, relecture, version };
        this.versionSelected.emit({ id, flow, relecture, version });
    }

    isSelected(flowItem: IHistoriesHandler, relecture: number, version?: number) {
        return this.selectedVersion?.id === flowItem.id
            && this.selectedVersion?.flow === flowItem.flow
            && this.selectedVersion?.relecture === relecture
            && this.selectedVersion?.version === version;
    }

    resetSelectedVersion() {
        this._selectedVersion = null;
        this.versionSelected.emit(null);
    }

    parseKey(key: string): number {
        return Number(key.replace(/[^0-9]/g, ''));
    }

    hasApprovalHistory(flowItem: IHistoriesHandler, relecture: string) {
        if (this.compare) {
            return this.projectHistory.some(ph => ph.id === flowItem.id && ph.flow === flowItem.flow && ph.approval?.history && Object.keys(ph.approval.history).includes(relecture));
        }
        return this.s_auth.isCPP() || this.projectHistory.some(ph => ph.id === flowItem.id && ph.flow === flowItem.flow && ph.approval?.history && Object.keys(ph.approval.history).includes(relecture));
    }

    hasContent() {
        for (const flow of this.projectHistory) {
            if ((flow.approval?.history && Object.keys(flow.approval?.history).length > 0) || (flow.intern?.history && Object.keys(flow.intern?.history).length > 0)) { //|| (flow.extern?.history && Object.keys(flow.extern?.history).length > 0)
                return true;
            }
        }
        return false;
    }

      getColorFlow(flow:FlowType): string {
           return CLIENT_CONFIG.getFlowConfig(flow).style.bg_color;
    }
}